import { Card, Select, Table, message } from 'antd';
import React, { useEffect, useState } from 'react';
import { CompanyService } from '../../services';


export const CompanyCreditParameters = (props) => {

	const [cibilParameter, setCibilParameter] = useState({});
	const [updateCibilParamData , setUpdateCibilParamData] = useState([]);

	const columns = [
        {
            title: "Parameter",
            dataIndex: "parameter",
            key: "parameter",
        },
        {
            title: "Value",
            dataIndex: "value",
            key: "value",
            render: (props, row) => ( 
                <Select key={"AB"} style={{minWidth : "70px"}} defaultValue={row.value} onChange={(value) => onValueSelect(props, row, value)}>
                    <Select.Option value={"Yes"}>Yes</Select.Option>
                    <Select.Option value={"No"}>No</Select.Option>
                </Select>
            ),
        }
    ];


	const onValueSelect =(props, row, value)=>{
        let orginalData = cibilParameter;
        let data = cibilParameter["commercial_cibil"];
        data.map((item) => {
            if(item.parameter == row.parameter){
                item.value = value;
            }
        });
        orginalData["commercial_cibil"] = data;
		setUpdateCibilParamData(orginalData);
    }


	useEffect(() => {
		CompanyService.companyPostCibilParameter(props.companyId).then(_ => {
        });
		CompanyService.getCompanyCibilParameter(props.companyId).then(_ => {
			setCibilParameter(_.data['credit_parameters']);
		});
	},[])

	const updateCibilParameter=(value)=>{
        let postData = {"credit_parameters" : value };
        CompanyService.updateCompanyCibilParameter(props.companyId, postData).then(() => {
            CompanyService.getCompanyCibilParameter(props.companyId).then(_ => {
				setCibilParameter(_.data['credit_parameters']);
            });
            message.success("Cibil parameter updated successfuly!");
        }).catch((err) => {
            message.success("Cibil parameter update failed!");
        });
    }


	return (
		<Card
			title={"CIBIL Comercial"}
			className={"padless-card small-card-title"}

			extra={
				<a
					key={"icon"}
					onClick={() => updateCibilParameter(updateCibilParamData)}
					// disabled={this.props.recreditViewOnlyPermission}
				>
					{" "}
					Update
				</a> 
			}
		>
			<Table
				dataSource={cibilParameter['commercial_cibil'] || []}
				columns={columns}
				pagination={false}
			/>
		</Card>
	)
}

